const RarityMaster = [
  { name: 'Plain', rarity: 1 },
  { name: 'Mercury', rarity: 2 },
  { name: 'Venus', rarity: 3 },
  { name: 'Earth', rarity: 4 },
  { name: 'Mars', rarity: 5 },
  { name: 'Jupiter', rarity: 6 },
  { name: 'Saturn', rarity: 7 },
  { name: 'Uranus', rarity: 8 },
  { name: 'Neptune', rarity: 9 },
  { name: 'Pluto', rarity: 10 },
]

export const getRarityName = (rarity: number) => RarityMaster.find((m) => m.rarity === rarity)?.name ?? ''
